export class ExportManager {
    constructor(store) {
        this._store = store;
    }
    json(fileName) {
        const { cards, links, columns, rows } = this._store.getState();
        const data = { cards, links, columns };
        if (rows.length > 0) {
            data.rows = rows;
        }
        this._save(data, `${fileName || "kanban-export"}`, "json");
    }
    _save(data, fileName, fileExtension) {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        const json = JSON.stringify(data);
        const blob = new Blob([json], { type: "octet/stream" });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = `${fileName}.${fileExtension}`;
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
}
//# sourceMappingURL=ExportManager.js.map